import {
  FETCH_BANNERS,
  FETCH_BANNERS_SUCCESS,
  FETCH_BANNERS_FAILED,
  EDIT_BANNERS
} from "../store/types";
import { firebase } from '../config/configureFirebase';
import { onValue, push, set, remove } from "firebase/database";
import { uploadBytesResumable, getDownloadURL } from "firebase/storage";

export const fetchBanners = () => (dispatch) => {
  const { bannersRef } = firebase;

  dispatch({
    type: FETCH_BANNERS,
    payload: null
  });

  onValue(bannersRef, snapshot => {
    if (snapshot.val()) {
      const data = snapshot.val();
      const arr = Object.keys(data).map(i => {
        data[i].id = i;
        return data[i];
      });
      dispatch({
        type: FETCH_BANNERS_SUCCESS,
        payload: arr
      });
    } else {
      dispatch({
        type: FETCH_BANNERS_SUCCESS,
        payload: []
      });
    }
  }, error => {
    dispatch({
      type: FETCH_BANNERS_FAILED,
      payload: error.message
    });
  });
};

export const editBanner = (banner, method) => async (dispatch) => {
  const {
    bannersRef,
    bannerEditRef,
    bannerImageRef
  } = firebase;

  dispatch({
    type: EDIT_BANNERS,
    payload: { method, banner }
  });

  if (method === 'Add') {
    const newRef = push(bannersRef);
    const id = newRef.key;
    let data = { ...banner, createdAt: banner.createdAt || new Date().getTime(), updatedAt: new Date().getTime() };
    if (banner.imageFile) {
      await uploadBytesResumable(bannerImageRef(id), banner.imageFile);
      data.image = await getDownloadURL(bannerImageRef(id));
      delete data.imageFile;
    }
    await set(newRef, data);
  } else if (method === 'Delete') {
    await remove(bannerEditRef(banner.id));
  } else {
    let data = { ...banner, updatedAt: new Date().getTime() };
    delete data.tableData;
    if (banner.imageFile) {
      await uploadBytesResumable(bannerImageRef(banner.id), banner.imageFile);
      data.image = await getDownloadURL(bannerImageRef(banner.id));
      delete data.imageFile;
    }
    await set(bannerEditRef(banner.id), data);
  }
};
